import React, { useState } from "react";
import { HiMenuAlt3, HiX } from "react-icons/hi";
import {
  FaInstagram,
  FaTwitter,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Top Nav */}
      <header className="fixed top-0 left-0 right-0 bg-white/40 backdrop-blur-lg border border-white/20 rounded-3xl px-6 py-4 flex items-center justify-between max-w-7xl mx-auto z-50 mt-6">
        <a href="/">
          <img
            src="/media/logo.webp"
            alt="Zesty Taste Logo"
            className="h-12 object-contain"
          />
        </a>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-2xl text-white z-50"
        >
          {isOpen ? <HiX /> : <HiMenuAlt3 />}
        </button>
      </header>

      {/* Fullscreen Overlay Menu */}
      {isOpen && (
        <div className="fixed inset-0 pt-24 bg-black/90 z-40 text-white flex flex-col items-center justify-start">
          {/* Navigation Items */}
          <nav className="flex flex-col gap-6 text-center mt-16 text-2xl font-semibold">
            <a href="/" className="hover:opacity-80">
              Home
            </a>
            <a href="/fruit-pulp" className="hover:opacity-80">
              Fruit Pulp
            </a>
            <a href="/marinated-chicken" className="hover:opacity-80">
              Marinated Chicken
            </a>
            <a href="/seafood" className="hover:opacity-80">
              Seafood
            </a>
            <a href="/brochure" className="hover:opacity-80">
              Brochure
            </a>
            <a href="/about-us" className="hover:opacity-80">
              About Us
            </a>
            <a href="/contact-us" className="hover:opacity-80">
              Contact Us
            </a>
          </nav>

          {/* Bottom Tagline + Social Icons */}
          <div className="absolute bottom-8 bg-primary text-white px-8 py-6 rounded-2xl text-center">
            <p className="text-2xl font-bold font-serif mb-4">
              Natural solutions for our customers.
            </p>
            <div className="flex justify-center gap-6 text-xl">
              <FaInstagram />
              <FaTwitter />
              <FaFacebookF />
              <FaLinkedinIn />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SiteHeader;
